export const BACKEND_BASE_URL = process.env.NODE_ENV === "production" ? "https://shit-backend.wurstempire.de" : "http://localhost:3000";
